import { AxiosError } from 'axios';
import { APIGatewayResponse } from '@dxb-web-ui-framework/common/domain/RestfulDataTransfer/DataService/types';
import { Nullable } from '@dxb-web-ui-framework/common/types';
import { Account } from '../../domain/Account/entities';

export enum AliasActionsEnum {
  upsert = 'UPSERT',
  delete = 'DELETE',
}

export type AliasState = {
  alias: Nullable<string>;
  action: Nullable<AliasActionsEnum>;
  selectedAccountForAction: Nullable<Account & { timestamp: string }>;
  onAccountSelectionForAction: (account: Account) => void;
  onResetAccountSelectionForAction: () => void;
  onAliasAction: (alias: string | undefined) => void;
  loadingState: {
    isLoadingUpsertAlias: boolean;
    isLoadingDeleteAlias: boolean;
  };
  errorState: {
    upsertAliasError?: AxiosError<APIGatewayResponse<any>, any>;
    deleteAliasError?: AxiosError<APIGatewayResponse<any>, any>;
  };
  // TODO: add correct types
  upsertAliasData: any;
  deleteAliasData: any;
};

export enum AliasContextActionTypes {
  SetAliasAction = '@@Account/SET_ALIAS_ACTION',
  SetSelectedAccountForAction = '@@Account/SET_SELECTED_ACCOUNT_FOR_ACTION',
  ResetSelectedAccountForAction = '@@Account/RESET_SELECTED_ACCOUNT_FOR_ACITON',
}
